"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _i18n = require("@/assets/js/i18n");

var _vuex = require("vuex");

var _routeSplicing = _interopRequireDefault(require("@/assets/js/routeSplicing"));

var _finance = require("@/model/finance/finance");

var _index = require("@/model/exchange/index");

var _keymap = require("@/assets/js/keymap.js");

var _NoData = _interopRequireDefault(require("@/components/common/NoData"));

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

var _formatDate = require("@/assets/js/formatDate");

var _financialDialog = _interopRequireDefault(require("./components/financial-management/financial-dialog"));

var _confirmDialog = _interopRequireDefault(require("./components/financial-management/confirm-dialog.vue"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import Countdown from "@choujiaojiao/vue2-countdown";
var _default = {
  mixins: [_commonMixin.default],
  name: "finances-index",
  components: {
    NoData: _NoData.default,
    // Countdown,
    FinancialDialog: _financialDialog.default,
    ConfirmDialogContent: _confirmDialog.default
  },
  data: function data() {
    return {
      rateTypeMaps: _keymap.rateTypeMaps,
      quantTagMaps: _keymap.quantTagMaps,
      buyNumber: "",
      voucherInterval: null,
      rightForm: {},
      dataList: [],
      confirmDialogTitle: "量化理财",
      listType: [{
        text: "Defi挖矿",
        val: 1
      }, {
        text: "云矿机",
        val: 2
      }],
      active: 1,
      rate1: 1,
      rate2: 1,
      currTab: 1,
      tabList: [{
        value: "1",
        label: "7日年化"
      }, {
        value: "2",
        label: "30日年化"
      }, {
        value: "3",
        label: "历史净值"
      }],
      pageLoading: false,
      financialDialogVisible: false,
      confirmDialogVisible: false,
      successDialogVisible: false,
      productId: "",
      apiAssetsInfo: "",
      productInfo: {
        product_id: 33,
        product_name: "--",
        item_id: 10007,
        channel_id: 101,
        item_type: 1,
        to_item_id: 10069,
        to_item_id_price: "--",
        product_type: 4,
        rate_type: 1,
        quant_tag: 0,
        annual_rate: "--",
        min_fluctuation_annual_rate: "--",
        max_fluctuation_annual_rate: "--",
        day_rate: "--",
        current_rate: "--",
        period: 1,
        start_time: 0,
        stop_time: 0,
        lock_period: "--",
        amount: 0,
        lowest_amount: 0,
        total_amount: "--",
        min_amount: "--",
        max_amount: "--",
        per_min_num: 1,
        per_max_num: 200,
        number_precision: 2,
        price_precision: 2,
        amount_precision: 2,
        trader_profit: 0,
        status: 7,
        union_product_id: 0,
        union_order_by: 1,
        is_union_master: 0,
        public_raise_amount: "--",
        ico_buy_condition: 1,
        ico_user_register_time: 0,
        is_hide: 0,
        is_show_list: 1,
        is_recommand: 1,
        is_delete: 0,
        access_type: 1,
        order_by: 1,
        i18n_lang: "static_finances_product_product_name_330",
        create_time: 1620324487,
        update_time: 1620975363,
        detail: {
          product_id: 33,
          product_intro: "",
          inout_rule: "",
          earnings_rule: "",
          product_code: "--",
          strategy: "",
          ico_url: "https://top6688.zendesk.com/hc/zh-cn/articles/4402147339921-%E8%AE%A4%E8%AF%86-O3",
          ico_eg: "",
          buy_rule: "--",
          risk_tip: "--",
          join_rule: "",
          i18n_lang: "ico_url_31,ico_eg_33,buy_rule_31,risk_tip_31,join_rule_0,product_code_33"
        },
        item_name: "USDT",
        item_url: require("../../assets/img/holder-coin-ico.png"),
        to_item_url: "https://imgs-dev.aevwjlae.com/admin/20210505/98506549656.png",
        to_item_name: "--",
        end_time: 1621580400,
        user_profit: 1,
        show_profit: 0
      }
    };
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapGetters)({
    userInfo: "user/userInfo",
    language: "user/language"
  })), {}, {
    heightClass: function heightClass() {
      return "active" + this.active;
    }
  }),
  created: function created() {
    var _this = this;

    return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getProductlist();

              _context.next = 3;
              return _this.getAssets();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  mounted: function mounted() {},
  methods: {
    routeSplicing: _routeSplicing.default,
    timestampToDate: _formatDate.timestampToDate,
    translateTitle: _i18n.translateTitle,
    onProductInfoChange: function onProductInfoChange(productInfo) {
      this.productInfo = productInfo;
    },
    getAssets: function getAssets() {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, _yield$apiGetAssets, status, data, tempDate;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.userInfo) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                params = {
                  type: "remain"
                };
                _context2.next = 5;
                return (0, _index.apiGetAssets)(params);

              case 5:
                _yield$apiGetAssets = _context2.sent;
                status = _yield$apiGetAssets.status;
                data = _yield$apiGetAssets.data;

                if (status == 200) {
                  tempDate = data.remain.list;
                  tempDate.forEach(function (ele) {
                    if (ele.item_id == 10007) {
                      _this2.apiAssetsInfo = ele.over;
                    }
                  });
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    onDialogClose: function onDialogClose() {
      this.financialDialogVisible = false;
    },
    onConfirm: function onConfirm() {
      this.confirmDialogVisible = true;
    },
    onConfirmCancel: function onConfirmCancel() {
      this.confirmDialogVisible = false;
    },
    onSuccess: function onSuccess() {
      this.successDialogVisible = false;
      this.getProductlist();
    },
    onConfirmOK: function onConfirmOK() {
      this.confirmDialogVisible = false;
      this.financialDialogVisible = false;
      this.successDialogVisible = true;
    },
    onClickAll: function onClickAll() {
      this.buyNumber = this.apiAssetsInfo;
    },
    // 选项卡切换
    onTypeChange: function onTypeChange(val) {
      this.active = val;

      if (val == 1) {
        this.confirmDialogTitle = "Defi挖矿";
      } else if (val == 2) {
        this.confirmDialogTitle = "云矿机";
      }

      this.getProductlist();
    },
    goToBuy: function goToBuy(item) {
      var _this3 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.productId = item.product_id;
                _this3.financialDialogVisible = true;

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    goToUseCenter: function goToUseCenter() {
      this.$router.push({
        path: this.routeSplicing(this.language, "ucenter/finanManagement")
      });
    },
    getProductlist: function getProductlist() {
      var _this4 = this;

      this.pageLoading = true;
      (0, _finance.apiGetDeFiProductList)().then(function (res) {
        if (res.status == 200) {
          var tempList = res.data;
          _this4.dataList = tempList;
        }

        _this4.pageLoading = false;
      });
    }
  }
};
exports.default = _default;